import React from 'react';
import { Grid } from 'semantic-ui-react';
import styles from './DesktopFooter.styles';

const today = new Date()
const TextBlurb = () => (
  <Grid.Column width={16} style={styles.column}>
    <p style={styles.footerBlurbText}>
      The Huddle is a member of the Pro Football Writers of America, Fantasy
      Sports Trade Association and Fantasy Sports Writers Association.
    </p>
    <p style={styles.footerBlurbText}>
      Use of this website constitutes acceptance of its <a style={styles.footerBlurbLink} href="https://static.usatoday.com/privacy/" target="_blank">Privacy Notice</a> and <a style={styles.footerBlurbLink} href="https://static.usatoday.com/terms/" target="_blank">Terms
      of Use</a>.{' '}
    </p>
    <p style={styles.footerBlurbText}>© { today.getFullYear() } THEHUDDLE.COM</p>
    <p style={styles.footerBlurbText}>
      Part of USA TODAY Sports Digital Properties
    </p>
  </Grid.Column>
);

export default TextBlurb;



// WEBPACK FOOTER //
// ./src/app/components/Footer/DesktopFooter/TextBlurb.js